export const SUPPORTED_FEATURES_MAPPER: Record<string, string> = {
  approved_loan_input: 'approved_loan_input',
  probability_estimator: 'probability_estimator',
  rac: 'rac',
  vehicle_details_from_jdp: 'vehicle_details_from_jdp',
  is_sms_sending_enabled: 'is_sms_sending_enabled',
  is_email_sending_enabled: 'is_email_sending_enabled',
  credit_interview: 'credit_interview',
  is_payment_option_active: 'is_payment_option_active',
};
